// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2UZ3g","item":"PaymentsMobile_item__37xTP","label":"PaymentsMobile_label__2RAFA","amount":"PaymentsMobile_amount___zvgk"};